import { render, staticRenderFns } from "./SearchList.vue?vue&type=template&id=b2d4aa0e&scoped=true&"
import script from "./SearchList.vue?vue&type=script&lang=js&"
export * from "./SearchList.vue?vue&type=script&lang=js&"
import style0 from "./SearchList.vue?vue&type=style&index=0&id=b2d4aa0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d4aa0e",
  null
  
)

export default component.exports